import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import "../components/SponsorListItem";
import axios from "axios";
var SponsorsView = /** @class */ (function (_super) {
    tslib_1.__extends(SponsorsView, _super);
    function SponsorsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.sponsorAdded = false;
        _this.error = null;
        return _this;
    }
    SponsorsView.prototype.routed = function () {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(store.selectedEvent.sponsors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                Vue.set(s, 'sendingEmail', false);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.sponsorAdded = this.$route.query.sponsorAdded !== undefined;
        store.page.title = this.$t("sponsorsView.title");
        store.page.showTopNav = true;
    };
    SponsorsView.prototype.inviteSponsor = function () {
        this.$router.push("/invite-sponsor");
    };
    SponsorsView.prototype.reInvite = function (sponsor) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        sponsor.sendingEmail = true;
                        return [4 /*yield*/, axios.post("sponsors/invite-email", {
                                eventId: this.store.selectedEvent.eventId,
                                emails: [sponsor.email]
                            })];
                    case 1:
                        _a.sent();
                        sponsor.invitedOn = new Date(Date.now());
                        return [3 /*break*/, 4];
                    case 2:
                        e_2 = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        sponsor.sendingEmail = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SponsorsView.prototype.sendBill = function (sponsor) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.post("sponsors/" + sponsor.sponsorId + "/sendbill")];
                    case 1:
                        _a.sent();
                        sponsor.billSentOn = new Date(Date.now());
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.error = err_1;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SponsorsView.prototype.addSponsor = function () {
        this.$router.push("/add-sponsor");
    };
    SponsorsView.prototype.sendReminder = function (sponsor) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        sponsor.sendingEmail = true;
                        return [4 /*yield*/, axios.post("sponsors/reminder-email", sponsor)];
                    case 1:
                        _a.sent();
                        sponsor.notificationSentOn = new Date(Date.now());
                        return [3 /*break*/, 4];
                    case 2:
                        e_3 = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        sponsor.sendingEmail = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SponsorsView.prototype, "participatingSponsors", {
        get: function () {
            return store.selectedEvent.sponsors.filter(function (s) {
                return s.participationStatus === "Participates";
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SponsorsView.prototype, "paidSponsors", {
        get: function () {
            return store.selectedEvent.sponsors.filter(function (s) { return s.participationStatus === "Paid"; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SponsorsView.prototype, "invitedSponsors", {
        get: function () {
            return store.selectedEvent.sponsors.filter(function (s) { return s.participationStatus === "NotAnswered" && s.invitedOn != null; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SponsorsView.prototype, "refusedSponsors", {
        get: function () {
            return store.selectedEvent.sponsors.filter(function (s) { return s.participationStatus === "Refused"; });
        },
        enumerable: true,
        configurable: true
    });
    SponsorsView = tslib_1.__decorate([
        Component
    ], SponsorsView);
    return SponsorsView;
}(Vue));
export default SponsorsView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/SponsorsView.vue
// module id = 70
// module chunks = 0